/*
 * The real app constraint on how many periods a timeline can span — not the
 * design mock's fabricated 5-24 range, which was prototype filler data.
 */
export const PERIODS_LIMIT = 15

/*
 * Values mirror `RepositoryTimeline['freq']` / `ANALYTICS_PERIOD_NAMING`'s keys
 * (src/store/analytics/utils/const.ts) so this option list stays wire-compatible
 * with the backend contract; labels match the design mock.
 */
export const PERIOD_TYPE_OPTIONS = [
  { value: 'day', label: 'DAILY' },
  { value: 'week', label: 'WEEKLY' },
  { value: 'month', label: 'MONTHLY' },
  { value: 'quarter', label: 'QUARTERLY' },
  { value: 'year', label: 'YEARLY' },
] as const
